import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ChipExtractionSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ChipExtractionSVG;
